exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-a520af38] .md-checkbox-container {\n  top: 10px;\n}\n[data-v-a520af38] .md-checkbox-label {\n  opacity: 1 !important;\n  color: black !important;\n}\n[data-v-a520af38] div.md-field.no-underline:after {\n  height: 0px;\n}\n[data-v-a520af38] .md-checkbox {\n  margin-top: 0px;\n}\n", ""]);

// exports
